/** Painel — a unidade básica de agrupamento visual. Distingue-se por fundo + filete, nunca sombra. */
import type { ReactNode } from 'react';

export interface PanelProps {
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export function Panel({ title, actions, children, footer, className }: PanelProps) {
  return (
    <section className={['panel', className].filter(Boolean).join(' ')}>
      {title || actions ? (
        <div className="panel-head">
          {typeof title === 'string' ? <h2 className="panel-title">{title}</h2> : title}
          {actions}
        </div>
      ) : null}
      <div className="panel-body">{children}</div>
      {footer ? <div className="panel-foot">{footer}</div> : null}
    </section>
  );
}
